module.exports = __webpack_public_path__ + "static/media/sleep-basics.f448b979.png";